export const menuItems = [
  {
    title: "Dashboard",
    root: true,
    icon: "Dashboard-icon.svg",
    page: "/dashboard",
    translate: "MENU.Dashboard",
    isubmenu: "0",
    iscountrequired: "0",
    type: [
      "Requester",
      "Approver",
      "Admin",
      "Non Admin",
      "HRAdmin",
      "ITAdmin",
      "FocalAdmin",
    ],
    subpage: [""],
  },
  {
    title: "Admin",
    root: true,
    icon: "manage-accounts.svg",
    page: "/",
    translate: "MENU.Admin",
    isubmenu: "1",
    iscountrequired: "1",
    type: ["Admin", "ITAdmin"],
    subpage: [
      "/edoctype/list",
      "/edoctype/edit",
      "/edoctype/view",
      "/delegation/list",
      "/delegation",
    ],
    submenu: [
      {
        title: "eDoc Type",
        icon: "metro-files.svg",
        translate: "MENU.edoctype",
        page: "/edoctype/list",
        type: ["Requester", "Approver", "Admin", "Non Admin", "ITAdmin"],
      },
      {
        title: "Delegation",
        icon: "call-split.svg",
        translate: "MENU.delegation",
        page: "/delegation/list",
        type: ["Requester", "Approver", "Admin", "Non Admin", "ITAdmin"],
      },
    ],
  },
  {
    title: "My Application",
    root: true,
    icon: "My-appliction-icon.svg",
    page: "/",
    translate: "MENU.Myapplication",
    isubmenu: "1",
    iscountrequired: "1",
    type: [
      "Requester",
      "Approver",
      "Admin",
      "Non Admin",
      "HRAdmin",
      "ITAdmin",
      "FocalAdmin",
    ],
    subpage: [
      "/draft/list",
      "/revision/list",
      "/pending/list",
      "/approved/list",
      "/rejected/list",
      "/cancelled/list",
      "/pendinggoodsreturn/list",
      "/Pendingconfirmgoodsreturn/list",
      "/securitycancelled/list",
    ],
    submenu: [
      {
        title: "Draft",
        icon: "draft.svg",
        translate: "MENU.revision",
        page: "/draft/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
      {
        title: "Pending",
        icon: "pendig-icon.svg",
        translate: "MENU.pending",
        page: "/pending/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
      {
        title: "Approved",
        icon: "approvrd.svg",
        translate: "MENU.approved",
        page: "/approved/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
      {
        title: "Rejected",
        icon: "rejected.svg",
        translate: "MENU.rejected",
        page: "/rejected/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
      {
        title: "Cancelled",
        icon: "cancelled.svg",
        translate: "MENU.cancelled",
        page: "/cancelled/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
    ],
  },

  {
    title: "My Task",
    root: true,
    icon: "approvrd.svg",
    page: "/mytask/pending/list",
    translate: "MENU.MyTask",
    isubmenu: "1",
    iscountrequired: "1",
    type: [
      "Requester",
      "Approver",
      "Admin",
      "Non Admin",
      "HRAdmin",
      "ITAdmin",
      "FocalAdmin",
    ],
    subpage: [
      "/mytask/approved/list",
      "/mytask/approved/view",
      "/mytask/approved/workflow",
      "/mytask/pending/list",
      "/mytask/pending/view",
      "/mytask/pending/workflow",
      "/mytask/rejected/list",
      "/mytask/rejected/view",
      "/mytask/rejected/workflow",
    ],
    submenu: [
      {
        title: "Pending",
        icon: "pendig-icon.svg",
        translate: "MENU.MyTask_Pending",
        page: "/mytask/pending/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
      {
        title: "Approved",
        icon: "approvrd.svg",
        translate: "MENU.MyTask_Approved",
        page: "/mytask/approved/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
      {
        title: "Rejected",
        icon: "rejected.svg",
        translate: "MENU.MyTask_Rejected",
        page: "/mytask/rejected/list",
        type: [
          "Requester",
          "Approver",
          "Admin",
          "Non Admin",
          "HRAdmin",
          "ITAdmin",
          "FocalAdmin",
        ],
      },
    ],
  },
  {
    title: "Reports",
    root: true,
    icon: "Reports.svg",
    page: "/",
    translate: "MENU.Reports",
    isubmenu: "1",
    iscountrequired: "0",
    type: ["HRAdmin", "ITAdmin"],
    subpage: ["/report"],
    submenu: [
      {
        title: "Employee Clearance Report",
        icon: "draft-report.svg",
        translate: "MENU.GGPReport",
        page: "/report",
        type: ["HRAdmin", "ITAdmin"],
      },
    ],
  },
  // {
  //   title: "Signature",
  //   root: true,
  //   icon: "sign.svg",
  //   page: "/signature",
  //   translate: "MENU.Dashboard",
  //   isubmenu: "0",
  //   iscountrequired: "0",
  //   type: [
  //     "Requester",
  //     "Approver",
  //     "Admin",
  //     "Non Admin",
  //     "HRAdmin",
  //     "ITAdmin",
  //     "FocalAdmin",
  //   ],
  //   subpage: [""],
  // },
];
